export const FEATURE_FLAG_KEYS = Object.freeze({
	featureFlagPilot: 'feature-flag-pilot',
	newFeatureAsdf: 'new-feature-asdf',
	frontendTestOne: 'frontend-test-one',
	frontendFlagTwo: 'frontend-flag-two',
	advancedBuild302: 'advanced-build-3-0-2',
	inspectMetaDemo: 'inspect-meta-demo'
});
